import api, { setHeaderToken, removeHeaderToken } from '../../../apis/Api'
import config from '../../../config'

import router from '@/router'

export default {
	namespaced: true,
	state: {
		statistic: {},
		loadDataRevenue: null,
		navigation: {},
		role_alias: '',
		user_detail: '',
		myAccess: [],
		name: ''
	},
	getters: {
		getLoadDataRevenue(state) {
			return state.loadDataRevenue
		},
		getNavigation(state) {
			return state.navigation
		},
		getRole_alias(state) {
			return state.role_alias
		},
		getUser_detail(state) {
			return state.user_detail
		},
		getMyAccess(state) {
			return state.myAccess
		},
		getName(state) {
			return state.name
		}
	},
	mutations: {
		setLoadDataRevenue(state, payload) {
			state.loadDataRevenue = payload
		},
		setNavigation(state, payload) {
			state.navigation = payload
		},
		setRole_alias(state, payload) {
			state.role_alias = payload
		},
		setUser_detail(state, payload) {
			state.user_detail = payload
		},
		setMyAccess(state, payload) {
			state.myAccess = payload
		},
		setName(state, payload) {
			state.name = payload
		}
	},
	actions: {
		login({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			return new Promise((resolve, reject) => {
				api({
					baseURL: config('api.baseUrl_auth'),
					method: 'post',
					url: `auth/login`,
					data: payload,
					withCredentials: false,
					headers: {}
				})
					.then((res) => {
						resolve(res)
						// if (res.respond.status == "success") {
						// function parseJwt (token) {
						var token = res.payload.accessToken
						var base64Url = token.split('.')[1]
						var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
						var jsonPayload = decodeURIComponent(
							window
								.atob(base64)
								.split('')
								.map(function(c) {
									return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
								})
								.join('')
						)
						console.log('JSON.parse(jsonPayload==)', JSON.parse(jsonPayload))
						const user_login = JSON.parse(jsonPayload)
						// if (user_login.RoleType == "ADMIN") {
						localStorage.setItem('user_login', JSON.stringify(JSON.parse(jsonPayload)))
						// localStorage.setItem(
						//   "refreshToken",
						//   res.respond.refreshToken
						// );
						localStorage.setItem('token', res.payload.accessToken)
						setHeaderToken(res.payload.accessToken)
						// dispatch("getProfile");
						// dispatch("getNotif", {userId: user_login.id});
						// dispatch("getMyAccess");
						dispatch(
							'location/getNotif',
							{
								url: `notif`,
								params: {
									userId: user_login.data.id,
									is_read: 0,
									offset: 0,
									limit: 5,
									order: 'desc'
								}
							},
							{ root: true }
						)

						dispatch(
							'location/getMyAccount',
							{
								url: `users/${user_login.data.id}`
							},
							{ root: true }
						)

						dispatch(
							'location/getCountEmergencies',
							{
								url: `user_emergency`,
								params: {
									// statusId: 9 //open
									// limit: this.pageSize,
									// order: this.order
								}
							},
							{ root: true }
						)

						// Setelah login berhasil, ambil OneSignal ID
						if (window.OneSignalDeferred) {
							window.OneSignalDeferred.push(async function(OneSignal) {
								try {
									const playerId = OneSignal.User.PushSubscription.id
									console.log('📡 Player ID:', playerId)

									if (playerId) {
										// Kirim ke backend
										dispatch('updatePlayerId', {
											id: user_login.data.id,
											data: {
												webPlayerId: playerId
											}
										})

										console.log('✅ Player ID sent to backend')
									}
								} catch (e) {
									console.error('❌ Gagal ambil atau kirim Player ID:', e)
								}
							})
						}

						router.push(`/`).catch(() => {})
						dispatch('setLoading', false)
					})
					.catch((err) => {
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},
		logout({ state, commit, dispatch, rootGetters }, payload) {
			removeHeaderToken()
			localStorage.removeItem('refreshToken')
			localStorage.removeItem('token')
			localStorage.removeItem('my_access')
			localStorage.removeItem('user_detail')
			localStorage.removeItem('notif')
			localStorage.removeItem('user_login')
		},
		logout2({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				baseURL: config('api.baseUrl_auth'),
				method: 'get',
				url: `auth/logout`,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.status == 'success') {
						removeHeaderToken()
						localStorage.removeItem('refreshToken')
						localStorage.removeItem('token')
						localStorage.removeItem('my_access')
						localStorage.removeItem('user_detail')
						localStorage.removeItem('notif')
						localStorage.removeItem('user_login')

						// localStorage.removeItem("navigation");
						// localStorage.removeItem("role_alias");
						// localStorage.removeItem("user");
						router.push(`/login`).catch(() => {})
					} else {
						alert(res.messages)
					}
					dispatch('setLoading', false)
				})
				.catch((err) => {
					if ((err.response.data.code == 400 && err.response.data.messages == 'Token has expired!') || err.response.status == 401) {
						alert('Token has expired! Silakan login kembali')
						localStorage.removeItem('refreshToken')
						localStorage.removeItem('token')
						localStorage.removeItem('my_access')
						localStorage.removeItem('user_detail')
						localStorage.removeItem('notif')
						localStorage.removeItem('user_login')
						router.push(`/`).catch(() => {})
					} else if (err.response.data.code == 400) {
						alert(err.response.data.messages)
						router.push(`/`).catch(() => {})
					}
					dispatch('setLoading', false)
					return false
				})
		},
		forgotpass({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			return new Promise((resolve, reject) => {
				api({
					baseURL: config('api.baseUrl_auth'),
					method: 'post',
					url: `auth/changepassword`,
					data: payload,
					headers: {}
				})
					.then((res) => {
						alert(res.payload.msg)
						resolve(res)
						dispatch('setLoading', false)
					})
					.catch((err) => {
						alert(err.response.data.payload)
						console.log('authjs=err' + err.response.data.payload)
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},
		changepass({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			return new Promise((resolve, reject) => {
				api({
					baseURL: config('api.baseUrl_auth'),
					method: 'post',
					url: `auth/changepass`,
					data: payload,
					withCredentials: false,
					headers: {}
				})
					.then((res) => {
						resolve(res)
						dispatch('setLoading', false)
					})
					.catch((err) => {
						console.log('authjs=err' + err)
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},

		updatePlayerId({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			return new Promise((resolve, reject) => {
				api({
					baseURL: config('api.baseUrl_push_notif'),
					method: 'PUT',
					url: `api/mobile/v1/user/web-player-id/${payload.id}`,
					data: payload.data,
					withCredentials: false,
					headers: {}
				})
					.then((res) => {
						resolve(res)
						dispatch('setLoading', false)
					})
					.catch((err) => {
						console.log('authjs=err' + err)
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},

		getProfile({ state, commit, dispatch, rootGetters }, payload) {
			// dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: `profile/detail`,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'failed') {
						console.log('getProfile==', res)
						// alert(res.messages)
						// router.push(`/dashboard`).catch(() => {});
						localStorage.setItem('user_detail', JSON.stringify([]))
					} else {
						// commit("setRole_alias", res.response.role_alias);
						commit('setName', {
							FirstName: res.respond.data.ContactName.split(/(?<=^\S+)\s/)[0],
							LastName: res.respond.data.ContactName.split(/(?<=^\S+)\s/)[1]
						})
						commit('setUser_detail', res.respond.data)
						localStorage.setItem('user_detail', JSON.stringify(res.respond.data))
						// localStorage.setItem("role_alias", res.response.role_alias);
					}
					// dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					// dispatch('setLoading', false)
					return false
				})
		},
		getNavigation({ state, commit, dispatch, rootGetters }, payload) {
			// dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'post',
				url: `resource`,
				data: {
					action: 'navigationGet'
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.status == 'failed') {
						alert(res.messages)
						// router.push(`/dashboard`).catch(() => {});
					} else {
						commit('setNavigation', res.response)
						localStorage.setItem('navigation', JSON.stringify(res.response))
						// JSON.parse(localStorage.getItem("navigation"))
					}
					// dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					// dispatch('setLoading', false)
					return false
				})
		},
		getNotif({ state, commit, dispatch, rootGetters }, payload) {
			// dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: `notif`,
				params: {
					userId: payload.userId,
					is_read: 0,
					// statusId: 9 //open
					// limit: this.pageSize,
					// order: this.order
					offset: 0,
					limit: 5,
					order: 'desc'
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'failed') {
						// alert(res.messages)
						console.log('getNotif==', res)
						// router.push(`/dashboard`).catch(() => {});
						localStorage.setItem('notif', JSON.stringify([]))
					} else {
						localStorage.setItem('notif', JSON.stringify(res.respond.data))
					}
					// dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					// dispatch('setLoading', false)
					return false
				})
		},
		notifRead({ state, commit, dispatch, rootGetters }, payload) {
			dispatch('setLoading', true)
			return new Promise((resolve, reject) => {
				api({
					method: 'post',
					url: `notif/admin/read`,
					data: payload.data,
					withCredentials: false,
					headers: {}
				})
					.then((res) => {
						resolve(res)
						dispatch('setLoading', false)
						dispatch('getNotif')
					})
					.catch((err) => {
						console.log('authjs=err' + err)
						reject(err)
						dispatch('setLoading', false)
						return false
					})
			})
		},

		getMyAccess({ state, commit, dispatch, rootGetters }, payload) {
			// dispatch('setLoading', true)
			let token = localStorage.getItem('token')
			api({
				method: 'get',
				url: `profile/access`,
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
				.then((res) => {
					if (res.respond.status == 'failed') {
						console.log('getMyAccess==', res)
						// alert(res.messages)
						localStorage.setItem('my_access', JSON.stringify([]))
					} else {
						commit('setMyAccess', res.respond.data)
						localStorage.setItem('my_access', JSON.stringify(res.respond.data))
						router.push(`/`).catch(() => {})
					}
					// dispatch('setLoading', false)
				})
				.catch((err) => {
					console.log('authjs=err' + err)
					// dispatch('setLoading', false)
					return false
				})
		},

		setLoading({ commit }, payload) {
			commit('loader/setLoading', payload, {
				root: true
			})
		}
	}
}
